import { useState } from "react";
import type { Review } from "@/mocks/reviews";

interface ReviewArticleProps {
  review: Review;
  anchorId?: string;
  defaultOpen?: boolean;
}

export default function ReviewArticle({ review, anchorId, defaultOpen = false }: ReviewArticleProps) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <article
      id={anchorId}
      className="scroll-mt-24 rounded-lg border border-background-200 bg-background-50 p-5"
    >
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 leading-7">
            {review.title}
          </h3>
          <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-user-line" />
              {review.author}
            </span>
            <span className="w-px h-3 bg-background-300" />
            <span>{review.date}</span>
            {review.tags.map((t) => (
              <span key={t} className="rounded-full bg-accent-100 px-2 py-0.5 text-accent-800">
                {t}
              </span>
            ))}
          </div>
        </div>
        <span className="shrink-0 w-9 h-9 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
          <i className="ri-quill-pen-line" />
        </span>
      </div>
      <p className="mt-3 text-sm leading-7 text-foreground-600">{review.excerpt}</p>
      {open && (
        <div className="mt-4 space-y-3 text-sm leading-7 text-foreground-700">
          {review.content.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      )}
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="mt-4 inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
      >
        {open ? "收起全文" : "展开全文"}
        <i className={open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} />
      </button>
    </article>
  );
}